import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SylloArchiveStrip = ({ puzzles, selectedDate }) => {
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();

  // Find the latest puzzle date to check if selected is today
  const latestPuzzleDate = puzzles[0]?.date;

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleSelectPuzzle = (puzzle) => {
    if (puzzle.date === latestPuzzleDate) {
      navigate('/todays-syllo-clues-answers');
    } else {
      navigate(`/syllo/syllo-${puzzle.puzzleNumber || puzzle.date}`);
    }
  };

  return (
    <div className="relative group max-w-6xl mx-auto px-4 mb-12 w-full">
      {/* Label */}
      <div className="flex items-center gap-4 mb-4">
        <div className="h-px bg-gray-200 flex-grow"></div>
        <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Syllo Archive</span>
        <div className="h-px bg-gray-200 flex-grow"></div>
      </div>

       {/* Scroll Buttons */}
       <button 
         onClick={() => scroll('left')}
         className="absolute left-0 top-1/2 mt-4 -translate-y-1/2 z-10 bg-white shadow-lg border border-gray-100 p-2 rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-all hover:scale-110 hidden md:block"
       >
         <ChevronLeft className="w-5 h-5" />
       </button>
       <button 
         onClick={() => scroll('right')}
         className="absolute right-0 top-1/2 mt-4 -translate-y-1/2 z-10 bg-white shadow-lg border border-gray-100 p-2 rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-all hover:scale-110 hidden md:block"
       >
         <ChevronRight className="w-5 h-5" />
       </button>

      <div 
        ref={scrollContainerRef}
        className="flex gap-3 overflow-x-auto pb-6 pt-2 scrollbar-hide snap-x px-2"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {puzzles.map((puzzle) => {
          const isSelected = puzzle.date === selectedDate;
          const dateObj = new Date(puzzle.date);
          const isToday = puzzle.date === latestPuzzleDate;
          
          return (
            <motion.button
              key={puzzle.date}
              onClick={() => handleSelectPuzzle(puzzle)}
              whileHover={{ y: -4 }}
              whileTap={{ scale: 0.95 }}
              className={`
                flex-shrink-0 snap-center
                flex flex-col items-center justify-center
                w-20 h-24 rounded-xl border-2 transition-all duration-300
                ${isSelected 
                  ? 'border-brand-blue bg-brand-blue text-white shadow-lg shadow-blue-200 rotate-1' 
                  : 'border-gray-200 bg-white text-gray-500 hover:border-brand-blue/50 hover:shadow-md'
                }
              `}
            >
              <span className={`text-[10px] font-bold uppercase mb-1 tracking-wider opacity-80`}>
                {isToday ? 'Today' : dateObj.toLocaleDateString('en-US', { month: 'short' })}
              </span>
              <span className={`text-2xl font-black ${isSelected ? 'text-white' : 'text-gray-900'}`}>
                {dateObj.getDate()}
              </span>
              <span className={`text-[10px] font-bold mt-1 opacity-80`}>
                {dateObj.toLocaleDateString('en-US', { weekday: 'short' })}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default SylloArchiveStrip;

